import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { VIDEO_FORMATS } from "../../../utils/constants";
import { adMediaPreviewTooltipSlotProps } from "../../../components/Common/AdMediaPreviewTooltipContent";
import GlobalReportCreativeBarTooltip from "./GlobalReportCreativeBarTooltip";

const THUMB_SIZE = 36;

const getUrlExtension = (url = "") => {
  const path = String(url).split("?")[0];
  const parts = path.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};

const isVideoMediaUrl = (url) => VIDEO_FORMATS.includes(getUrlExtension(url));

const CreativeThumbnail = ({ url }) => {
  if (!url) {
    return (
      <Box
        sx={{
          width: THUMB_SIZE,
          height: THUMB_SIZE,
          borderRadius: 1,
          border: "1px solid #E5E5E5",
          backgroundColor: "#F5F5F5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "text.disabled",
        }}
      >
        <ImageOutlinedIcon sx={{ fontSize: 18 }} />
      </Box>
    );
  }

  const mediaSx = {
    width: THUMB_SIZE,
    height: THUMB_SIZE,
    borderRadius: 1,
    border: "1px solid #E5E5E5",
    objectFit: "cover",
    display: "block",
    backgroundColor: "#F5F5F5",
  };

  if (isVideoMediaUrl(url)) {
    return (
      <Box
        component="video"
        src={url}
        muted
        playsInline
        preload="metadata"
        sx={mediaSx}
      />
    );
  }

  return <Box component="img" src={url} alt="" loading="lazy" sx={mediaSx} />;
};

const GlobalReportCreativeAxisTick = ({
  x = 0,
  y = 0,
  item,
  metricLabel,
  formatMetricValue,
  translatePlatform,
}) => {
  if (!item) {
    return null;
  }

  const thumbUrl = item.mediaUrls?.[0];
  const tooltipTitle = (
    <GlobalReportCreativeBarTooltip
      active
      payload={[{ payload: item }]}
      metricLabel={metricLabel}
      formatMetricValue={formatMetricValue}
      translatePlatform={translatePlatform}
    />
  );

  return (
    <g transform={`translate(${x},${y})`}>
      <foreignObject
        x={-THUMB_SIZE - 8}
        y={-THUMB_SIZE / 2}
        width={THUMB_SIZE}
        height={THUMB_SIZE}
        style={{ overflow: "visible" }}
      >
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{ width: THUMB_SIZE, height: THUMB_SIZE }}
        >
          <Tooltip
            title={tooltipTitle}
            placement="right"
            disableInteractive={false}
            enterDelay={200}
            leaveDelay={80}
            slotProps={adMediaPreviewTooltipSlotProps}
          >
            <span
              style={{
                display: "inline-flex",
                cursor: thumbUrl ? "pointer" : "default",
                lineHeight: 0,
              }}
            >
              <CreativeThumbnail url={thumbUrl} />
            </span>
          </Tooltip>
        </div>
      </foreignObject>
    </g>
  );
};

export default GlobalReportCreativeAxisTick;
